import { useNavigate, useSearchParams } from "react-router-dom";

import {
  buildCustomizationWorkbenchEntryPath,
  buildCustomizationWorkbenchFallbackPath,
  CustomizationProjectListFeaturePage,
  openCustomizationWorkbenchInNewWindow,
} from "..";

/** 定制项目列表页面入口。 */
export function CustomizationProjectListPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const shouldCreateOnEntry = searchParams.get("create") === "1";

  const openWorkbench = (projectId: string, options?: { jiDiaoNo?: string }) => {
    const search = options?.jiDiaoNo
      ? `?JiDiaoNo=${encodeURIComponent(options.jiDiaoNo)}`
      : undefined;
    const path = buildCustomizationWorkbenchEntryPath(projectId, { search });
    if (!openCustomizationWorkbenchInNewWindow(path)) {
      navigate(buildCustomizationWorkbenchFallbackPath(path));
    }
  };

  return (
    <CustomizationProjectListFeaturePage
      createOnEntry={shouldCreateOnEntry}
      onCreateSuccess={(projectId) => openWorkbench(projectId)}
      onOpenWorkbench={openWorkbench}
    />
  );
}
